import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DialogContentText, Grid, Typography } from '@material-ui/core';

import useStyles from './styles';

import SelectLinea from './SelectLinea';
import SelectEstaciones from './SelectEstaciones';
import DiasFechaHora from './DiasFechaHora';

import { setterBusqueda } from '../../redux/actions/serviciosActions';

import api from '../../helpers/api';

export default function TabServiciosBusqueda({ reset, setReset }) {
  const classes = useStyles();

  const busqueda = useSelector((state) => state.servicios.busqueda);
  const [estaciones, setEstaciones] = useState(null);

  const { token } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const [dataSearchServicio, setDataSearchServicio] = useState(busqueda);

  const handleInputChange = (e) => {
    const data = {
      ...dataSearchServicio,
      [e.target.name]: e.target.value,
    };
    setDataSearchServicio(data);
    dispatch(setterBusqueda(data));
  };

  useEffect(() => {
    async function getEstaciones() {
      return await api
        .get(`v1/estaciones`, {
          headers: {
            Authorization: token,
          },
        })
        .then((response) => {
          setEstaciones(response.data);
        });
    }
    getEstaciones();
  }, []);

  useEffect(() => {
    setReset(false);
    setDataSearchServicio(busqueda);
  }, [reset]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Fragment>
      <DialogContentText>
        Completá los datos para buscar los servicios disponibles
      </DialogContentText>
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <SelectLinea
            estaciones={estaciones}
            fieldSelected={dataSearchServicio.linea}
            setDataSearchServicio={handleInputChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='h6' className={classes.titleSection}>
            Elegí las estaciones
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectEstaciones
            estacionesGet={estaciones}
            lineaSelected={dataSearchServicio.linea}
            fieldSelected={dataSearchServicio.estacionOrigen}
            setDataSearchServicio={handleInputChange}
            sentido={'Estacion de Origen'}
            nameField={'estacionOrigen'}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectEstaciones
            estacionesGet={estaciones}
            lineaSelected={dataSearchServicio.linea}
            fieldSelected={dataSearchServicio.estacionDestino}
            setDataSearchServicio={handleInputChange}
            estacionOrigen={dataSearchServicio.estacionOrigen}
            sentido={'Estacion de Destino'}
            nameField={'estacionDestino'}
          />
        </Grid>
        <Grid item xs={12}>
          <DiasFechaHora
            fieldSelected={dataSearchServicio}
            setDataSearchServicio={handleInputChange}
            vuelta={false}
          />
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </Fragment>
  );
}
